import { request } from '../../../../sharedLegacy/utils/api'
import {
  HTTPMethod,
  type APIResponse,
} from '../../../../sharedLegacy/utils/api.types'

type SharingRequest = {
  live_id: number
  filename: string
  hidden_p: boolean
}

export async function startSharingAttachment(
  liveId: number,
  filename: string
): Promise<{}> {
  const { data } = await request<SharingRequest, APIResponse>({
    method: HTTPMethod.GET,
    url: '/api/2/live/attachment/set-hidden',
    data: {
      live_id: liveId,
      filename,
      hidden_p: false,
    },
  })
  return data
}

export async function stopSharingAttachment(
  liveId: number,
  filename: string
): Promise<{}> {
  const { data } = await request<SharingRequest, APIResponse>({
    method: HTTPMethod.GET,
    url: '/api/2/live/attachment/set-hidden',
    data: {
      live_id: liveId,
      filename,
      hidden_p: true,
    },
  })
  return data
}
